var map = {
	"./blue.png": "4901",
	"./corporate-man.png": "26fc",
	"./green.png": "9fc8",
	"./green_dark.png": "3cdf",
	"./happy-young-man.png": "57d6",
	"./logo.png": "9d64",
	"./orange.png": "0d74",
	"./pink.png": "cf87",
	"./raggruppa.png": "8098",
	"./red.png": "5be9",
	"./shape.png": "28e8",
	"./yellow.png": "57a6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";